export class WebSocketManager {
  private ws: WebSocket | null = null;
  private reconnectTimeout: any = null;
  private handlers: Map<string, (data: any) => void> = new Map();
  private token: string | null = null;

  connect(token: string): void {
    if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
      console.log('[WebSocket] Already connecting or connected, ignoring request');
      return;
    }

    this.token = token;
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const url = `${protocol}//${window.location.host}/ws?token=${token}`;

    console.log('[WebSocket] Connecting to', url);
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      console.log('[WebSocket] Connected');
      if (this.reconnectTimeout) {
        clearTimeout(this.reconnectTimeout);
        this.reconnectTimeout = null;
      }
    };

    this.ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        console.log('[WebSocket] Message received:', msg);
        // Sesión apuntando a un usuario que ya no existe. Se maneja acá y no
        // en un handler registrado porque debe funcionar aunque nadie lo haya
        // registrado, y porque reconectar cada 5s con el mismo token muerto
        // deja la UI a medias para siempre. Mismo desenlace que un 401 en
        // api.ts: se borra el token y se vuelve al login.
        if (msg.type === 'session_invalid') {
          console.warn('[WebSocket] Sesión inválida — cerrando sesión');
          this.disconnect();
          localStorage.removeItem('jwt');
          window.location.href = '/';
          return;
        }
        const handler = this.handlers.get(msg.type);
        if (handler) {
          handler(msg.data || msg);
        }
      } catch (err) {
        console.error('[WebSocket] Invalid message:', err);
      }
    };

    this.ws.onclose = () => {
      console.log('[WebSocket] Disconnected, reconnecting in 5s...');
      this.ws = null;
      this.reconnectTimeout = setTimeout(() => {
        if (this.token) {
          this.connect(this.token);
        }
      }, 5000);
    };

    this.ws.onerror = (err) => {
      console.error('[WebSocket] Error:', err);
    };
  }

  on(type: string, handler: (data: any) => void): void {
    this.handlers.set(type, handler);
  }

  send(type: string, data?: any): void {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({ type, ...data }));
    } else {
      console.warn('[WebSocket] Cannot send, not connected');
    }
  }

  disconnect(): void {
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = null;
    }
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    this.token = null;
    console.log('[WebSocket] Disconnected manually');
  }
}

export const wsManager = new WebSocketManager();
